import { render, staticRenderFns } from "./BoardMenu.vue?vue&type=template&id=430ed92e&scoped=true&"
import script from "./BoardMenu.vue?vue&type=script&lang=ts&"
export * from "./BoardMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BoardMenu.vue?vue&type=style&index=0&id=430ed92e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430ed92e",
  null
  
)

export default component.exports